// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"l1-z","dimensionLabel":"m1-z","styleChooserControlWrapper":"n1-z","styleChooserControl":"o1-z","disabled":"p1-z","giftCard":"q1-z","styleChooserText":"r1-z"};